import "./BaseLayer.css";

import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from "react";

import { useTranslation } from "react-i18next";
import { ServerTypeHelper } from "../../_config/helpers";
import { vector } from "../../_config/layers/";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

let baseLayerSwitcher = [];

const BaseLayer = forwardRef(({ map, onBaseLayerChange }, ref) => {
  const { t } = useTranslation();
  const restoreElement = useRef();

  const [active, setActive] = useState(false);
  const [selectedLayer, setSelectedLayer] = useState(null);
  const [groupedLayers, setGroupedLayers] = useState({});

  const handleClick = () => {
    vector.getSource().clear();
    setActive(true);
  };

  const handleClose = () => {
    setActive(false);
  };

  const handleBaseLayerClick = (title) => {
    setSelectedLayer(title);

    baseLayerSwitcher.forEach((layer) => {
      layer.setVisible(layer.get("title") === title);
    });

    if (onBaseLayerChange) {
      onBaseLayerChange(title);
    }
  };

  useImperativeHandle(ref, () => ({
    changeBaseLayer(title) {
      handleBaseLayerClick(title);
    }
  }));

  const buildBaseLayerTree = () => {
    const layersAux = [];
    const groups = {};
    let firstVisible = null;

    map.getLayers().getArray().forEach((layer) => {
      const isBaseLayer =
        layer.get("serverType") !== ServerTypeHelper.GEOSERVER &&
        layer.get("title") &&
        layer.get("title") !== "Grade" &&
        layer.get("title") !== "CSV";

      if (!isBaseLayer) return;

      const provider = layer.get("folder") || "Outros";
      const title = layer.get("title");

      layersAux.push(layer);

      if (!groups[provider]) {
        groups[provider] = [];
      }

      groups[provider].push(layer);

      if (layer.getVisible()) {
        firstVisible = title;
      }
    });

    baseLayerSwitcher = layersAux;

    setGroupedLayers(groups);

    if (!selectedLayer && firstVisible) {
      setSelectedLayer(firstVisible);
    }
  };

  useEffect(() => {
    buildBaseLayerTree();
  }, [map]);

  return (
    <div id="BaseLayer" className="BaseLayer">
      <Button
        className="HorizontalButton"
        type="button"
        title={t("baseLayer.changeBaseMap")}
        onClick={handleClick}
        ref={restoreElement}
        icon="pi pi-map"
      />

      <Dialog
        className="BaseLayerDialog"
        header={t("baseLayer.changeBaseMap")}
        visible={active}
        onHide={handleClose}
        modal
        dismissableMask
        closable
        appendTo={document.body}
        draggable={false}
        resizable={false}
        blockScroll
        style={{ width: "480px" }}
      >
        <div className="BaseLayerDialogBody">
          {Object.entries(groupedLayers).map(([provider, layers]) => (
            <div key={provider} className="BaseLayerGroup">

              <h5 className="BaseLayerProvider">
                {provider}
              </h5>

              <div className="BaseLayerList">
                {layers.map((layer, index) => {
                  const title = layer.get("title");

                  return (
                    <div
                      key={index}
                      className={`BaseLayerCard ${
                        selectedLayer === title ? "active" : ""
                      }`}
                      onClick={() => handleBaseLayerClick(title)}
                    >
                      <span className="BaseLayerIcon">
                        <i className="pi pi-map" />
                      </span>

                      <span className="BaseLayerTitle">
                        {title}
                      </span>

                      {selectedLayer === title && (
                        <span className="BaseLayerCheck">
                          <i className="pi pi-check" />
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
});

export default BaseLayer;